export default __webpack_public_path__ + "static/media/1.e4330daa.png";